import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { Reveal } from "./Motion";
import { RESULTS } from "../data/portfolio";

function Stat({ prefix = "", value, suffix = "", text, label, index }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (text != null || !inView) return;
    if (reduce) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 1.5,
      delay: index * 0.08,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v),
    });
    return () => controls.stop();
  }, [inView, value, reduce, index, text]);

  return (
    <div ref={ref} data-testid={`result-stat-${index}`} className="flex flex-col">
      <span className="font-display font-extrabold tracking-tighter leading-none text-5xl md:text-6xl lg:text-7xl text-white">
        {text != null ? (
          text
        ) : (
          <>
            {prefix}
            {Math.round(display)}
            {suffix}
          </>
        )}
      </span>
      <span className="mt-4 text-sm md:text-base text-white/50 max-w-[16ch]">{label}</span>
    </div>
  );
}

export default function ResultsStrip() {
  return (
    <section className="relative py-20 md:py-28 border-y border-white/10 bg-[#070707]" data-testid="results-strip">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-12">By the numbers</p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-14">
          {RESULTS.map((r, i) => (
            <Stat key={r.label} {...r} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
